module.exports = __webpack_public_path__ + "img/collection-weddingRingsExclusive.095501b.jpg";